import Carousel from 'react-bootstrap/Carousel'
import React, { Component } from 'react'
import {
  extendParentClass,
  extendBaseClass,
  extend,
} from '../../../../utils/classes'
import Stars from './Stars'
import Image from './Image'

export class Item extends Component {
  baseClass = extendParentClass.bind(this)('item')

  extend = extendBaseClass.bind(this)

  combineClasses = () => {
    const { className } = this.props
    return `${className} ${this.baseClass}`
  }

  render() {
    const { name, review, stars } = this.props
    const caption = this.extend('caption')
    const content = extend(caption, 'content')
    return (
      <Carousel.Item className={this.combineClasses()}>
        <Carousel.Caption className={caption}>
          <Image parentClass={caption} />
          <div className={extend(caption, 'review-btn')}></div>
          <div className={content}>
            <Stars stars={stars} parentClass={content} />
            <p className={extend(content, 'review')}>{review}</p>
            <h5 className={extend(content, 'name')}>{name}</h5>
          </div>
        </Carousel.Caption>
      </Carousel.Item>
    )
  }
}

export default Item
